import { Routes } from '@angular/router';
import { MorphemesPage } from './morphemes-page';
import { RecognizeShortestFormPage } from './recognize-shortest-form-page/recognize-shortest-form-page';
import { WordBuildingPage } from './word-building-page/word-building-page';
import { WordSnakePage } from './word-snake-page/word-snake-page';

export const mechanicMorphemeRoutes: Routes = [
  {
    path: '',
    component: MorphemesPage,
  },
  {
    path: 'recognize-shortest-form',
    component: RecognizeShortestFormPage,
  },
  {
    path: 'word-snake',
    component: WordSnakePage,
  },
  {
    path: 'word-building',
    component: WordBuildingPage,
  },
];
